import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import Counter from 'components/Luxkit/Counter'
import InputText from 'components/Luxkit/Typography/InputText'
import Group from 'components/utils/Group'
import React from 'react'

interface Props {
  adultsInputName: string
  defaultAdultsValue?: number
  childrenInputName: string
  defaultChildrenValue?: number
}

function TailorMadeTourOccupantsInputs({
  adultsInputName,
  defaultAdultsValue,
  childrenInputName,
  defaultChildrenValue,
}: Props) {
  return <VerticalSpacer gap={16}>
    <Group direction="horizontal" gap={8} horizontalAlign="space-between" verticalAlign="center">
      <div>
        <InputText variant="label">Adults</InputText>
        <InputText variant="sub-label" colour="neutral-three">18+ yrs</InputText>
      </div>
      <Counter
        name={adultsInputName}
        defaultValue={defaultAdultsValue ?? 2}
        max={10}
        min={1}
      />
    </Group>
    <Group direction="horizontal" gap={8} horizontalAlign="space-between" verticalAlign="center">
      <div>
        <InputText variant="label">Children</InputText>
        <InputText variant="sub-label" colour="neutral-three">0-17 yrs</InputText>
      </div>
      <Counter
        name={childrenInputName}
        defaultValue={defaultChildrenValue ?? 0}
        max={10}
        min={0}
      />
    </Group>
  </VerticalSpacer>
}

export default TailorMadeTourOccupantsInputs
